<template>
    <div id="footer" class="edith-bg-medium">
        <div id="button-footer-left">
            <b-button variant="outline-primary"
                      v-show="activeFooterConfiguration.left.visible"
                      :disabled="!activeFooterConfiguration.left.enabled()"
                      @click="activeFooterConfiguration.left.onclick">
                <b-icon-arrow-left-circle/>
                {{ activeFooterConfiguration.left.text }}
            </b-button>
        </div>
        <div id="version-number"><span>Version  {{ $store.getters.appVersion }}</span>
            <b-icon-dash-lg rotate="90" style="color:rgb(179 188 194)"/>
            <span><a href="https://www.ukaachen.de/impressum/" target="_blank">Impressum</a></span></div>
        <div id="button-footer-right">
            <b-button
                    :variant="activeFooterConfiguration.right.variant ? activeFooterConfiguration.right.variant : 'outline-primary'"
                    v-show="activeFooterConfiguration.right.visible"
                    :disabled="!activeFooterConfiguration.right.enabled()"
                    @click="activeFooterConfiguration.right.onclick"
                    v-b-hover="handleSaveButtonHover">
                {{ activeFooterConfiguration.right.text }}
                <b-icon-check-circle v-if="activeFooterConfiguration.right.icon==='check-circle'"/>
                <b-icon-list-ul v-else-if="activeFooterConfiguration.right.icon==='icon-list-ul'"/>
                <span v-else-if="activeFooterConfiguration.right.icon==='floppy-disk'">
          <img v-if=saveButtonHovered src="../../../../edith-app/src/assets/floppy-green-full.svg"
               height="20px" width="20px"
               alt="icon-blue-full">
          <img v-else src="../../../../edith-app/src/assets/floppy-green.svg" height="20px" width="20px"
               alt="icon-blue">
          </span>
                <b-icon-arrow-right-circle v-else/>
            </b-button>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {calculateAge} from "../../js/util";

export default {
    name: "Footer.vue",
    data() {
        return {
            activeFooterConfiguration: null,
            footerConfigurations: {
                'anfaelle': {
                    left: {
                        visible: false,
                        enabled: () => false
                    },
                    right: {
                        visible: true,
                        enabled: () => true,
                        text: 'Weiter',
                        onclick: () => this.$router.push('technische-untersuchungen')
                    }
                },
                'technische-untersuchungen': {
                    left: {
                        visible: true,
                        text: 'Zurück',
                        enabled: () => true,
                        onclick: () => this.$router.push('anfaelle')
                    },
                    right: {
                        visible: true,
                        enabled: () => this.diagnosestellungReachable,
                        text: 'Weiter',
                        onclick: () => this.$router.push('diagnose')
                    }
                },
                'diagnose': {
                    left: {
                        visible: true,
                        text: 'Zurück',
                        enabled: () => true,
                        onclick: () => this.$router.push('technische-untersuchungen')
                    },
                    right: {
                        visible: true,
                        enabled: () => true,
                        text: 'Diagnose bestätigen',
                        variant: 'outline-success',
                        icon: 'check-circle',
                        onclick: () => {
                            if (this.bestaetigteDiagnose !== 'not set yet' &&
                                ((this.patientIsWoman && this.patientIsPregnant !== 'irrelevant') || !this.patientIsWoman)) {
                                this.$store.commit('cdss/diagnosestellung/setDiagnoseConfirmed', true)
                                this.$router.push('empfehlung')
                            } else {
                                if (this.bestaetigteDiagnose === 'not set yet') {
                                    this.$store.commit('cdss/diagnosestellung/setBestaetigteDiagnoseSelected', false)
                                }
                                if (!((this.patientIsWoman && this.patientIsPregnant !== 'irrelevant') || !this.patientIsWoman)) {
                                    this.$store.commit('cdss/diagnosestellung/setPatientIsPregnantSelected', false)
                                }
                            }
                        }
                    }
                },
                'empfehlung': {
                    left: {
                        visible: true,
                        enabled: () => true,
                        text: 'Zurück',
                        onclick: () => this.$router.push('diagnose')
                    },
                    right: {
                        visible: true,
                        enabled: () => true,
                        text: 'Beenden',
                        variant: 'outline-success',
                        onclick: () => {
                          this.$store.reset() //the store is reset in all the levels and modules
                          //make sure we still have the ExpirationTime and TokenValidityDuration
                          this.$router.replace('/app/secure')
                        }
                    }
                },
                'footerDisabled': {
                    left: {
                        visible: false,
                        enabled: () => false
                    },
                    right: {
                        visible: false,
                        enabled: () => false
                    }
                }
            },
            saveButtonHovered: false,
        }
    },
    created() {
        this.activeFooterConfiguration = this.footerConfigurations.anfaelle
    },
    computed: {
        ...mapGetters('cdss',
            ['diagnosestellungReachable', 'showSavedData']),
        ...mapGetters('cdss/diagnosestellung',
            ['angegebeneNebendiagnosen',
                'keineRelevantenNebendiagnosenConfirmed',
                'bestaetigteDiagnose',
                'patientIsPregnant'
            ]),
        ...mapState('cdss', {
            patientIsWoman: state => {
                const patientAge = calculateAge(state.patient.birthDate) >= 60;
                return state.patient.sex === 'w' && !patientAge;
            },
          patientData: state => state.patient
        }),
    },
    watch: {
        '$route.name': function (route) {
            this.activeFooterConfiguration = this.footerConfigurations[route]
        },
        showSavedData(showTabs) {
            if (!showTabs) {
                console.log('showTabs', showTabs)
                this.activeFooterConfiguration = this.footerConfigurations.footerDisabled
            } else {
                this.activeFooterConfiguration = this.footerConfigurations[this.$route.name]
            }
        }
    },
    methods: {
        handleSaveButtonHover(hovered) {
            this.saveButtonHovered = hovered
        }
    }
}
</script>

<style scoped>

#footer {
    padding-top: 4px;
    display: grid;
    grid-template-areas: "left center right";
    grid-template-columns: 1fr auto 1fr;
}

#button-footer-left {
    grid-area: left;
    justify-self: left;
    padding-left: 10px;
}

#button-footer-right {
    grid-area: right;
    justify-self: right;
    padding-right: 10px;
}

#version-number {
    grid-area: center;
    text-align: center;
    justify-content: center;
    color: #5a6268;
    padding-top: 10px;
}

</style>